import { businessProfileFieldGroup, businessProfileSubmissionProblems, isBusinessProfileField, } from "./business-profile";
import { businessProfileProgress } from "./business-profile-wizard";
import { jsonValuesEqual } from "./util/equality";
export const businessProfileReviewSections = [
    "business",
    "address",
    "representative",
    "texting",
];
export const businessProfileReviewSectionLabels = {
    business: "Business",
    address: "Address",
    representative: "Representative",
    texting: "Texting",
};
const reviewSectionsByDetailsField = {
    legalName: "business",
    doingBusinessAs: "business",
    businessType: "business",
    industry: "business",
    ein: "business",
    website: "business",
    socialPage: "business",
    address: "address",
    representative: "representative",
    secondRepresentative: "representative",
    optInMethods: "texting",
    sampleMessages: "texting",
    privacyPolicyUrl: "texting",
    privacyPolicyStatements: "texting",
    callerIdName: null,
};
export const businessProfileReviewSectionForField = (field) => businessProfileFieldGroup(reviewSectionsByDetailsField, field);
export const outstandingBusinessProfileReview = (details) => {
    const problems = Object.entries(businessProfileSubmissionProblems(details));
    return businessProfileReviewSections.flatMap(section => {
        const problem = problems.find(([field]) => businessProfileReviewSectionForField(field) === section);
        return problem ? [{ section, problem: problem[1] }] : [];
    });
};
export const businessProfileReviewStatuses = [
    "inProgress",
    "readyForReview",
    "readyToSubmit",
    "submitted",
];
export const businessProfileReviewStatus = (status, details) => {
    const progress = businessProfileProgress(status, details);
    if (progress !== "readyForReview") {
        return progress;
    }
    return outstandingBusinessProfileReview(details).length === 0
        ? "readyToSubmit"
        : "readyForReview";
};
export const businessProfileFieldLabels = {
    legalName: "legal name",
    doingBusinessAs: "name customers know it by",
    businessType: "business type",
    industry: "industry",
    ein: "EIN",
    website: "website",
    socialPage: "social page",
    address: "address",
    representative: "representative",
    secondRepresentative: "second representative",
    optInMethods: "opt-in methods",
    sampleMessages: "sample messages",
    privacyPolicyUrl: "privacy policy link",
    privacyPolicyStatements: "privacy policy checks",
    callerIdName: "caller ID name",
};
const businessProfileFields = Object.keys(businessProfileFieldLabels).filter(field => isBusinessProfileField(businessProfileFieldLabels, field));
export const changedBusinessProfileFields = (before, after) => businessProfileFields.filter(field => !jsonValuesEqual(before[field], after[field]));
export const unnamedBusinessName = "Unnamed business";
export const businessProfileDisplayName = (details, fallback) => details.legalName.trim() || details.doingBusinessAs.trim() || fallback;
//# sourceMappingURL=business-profile-review.js.map